module.exports = {"340121100":"水湖镇","340121101":"庄墓镇","340121102":"杨庙镇","340121103":"吴山镇","340121104":"岗集镇","340121105":"双墩镇","340121106":"下塘镇","340121107":"朱巷镇","340121200":"罗塘乡","340121201":"义井乡","340121202":"陶楼乡","340121203":"造甲乡","340121204":"左店乡","340121205":"杜集乡","340121400":"双凤开发区","340121401":"安徽省水家湖农场"}


//////////////////
// WEBPACK FOOTER
// ./src/town/340121.json
// module id = 959
// module chunks = 0